'use strict';

var _ = require('lodash');

var CONTENT_AREA_MARKER_NAME_IN_DOM = 'content-area-marker';

var getContentAreaStartPosition = function getContentAreaStartPosition(contentAreaWidth, contentAreaPositionFactor) {
  return "calc((100% - " + contentAreaWidth + "px) * " + contentAreaPositionFactor + ")";
};

var contentAreaUtil = {
  getContentAreaMarkingElement: function getContentAreaMarkingElement(contentArea, compId) {
    var _ref;

    var width = contentArea.width,
        alignment = contentArea.alignment;
    return ['div', (_ref = {
      style: {
        visibility: 'hidden',
        position: 'absolute',
        width: width,
        marginLeft: getContentAreaStartPosition(width, alignment)
      },
      key: CONTENT_AREA_MARKER_NAME_IN_DOM
    }, _ref["data-" + CONTENT_AREA_MARKER_NAME_IN_DOM] = compId, _ref['data-aid'] = CONTENT_AREA_MARKER_NAME_IN_DOM + "-" + compId, _ref)];
  },
  getContentAreaMarkerChildOnNode: function getContentAreaMarkerChildOnNode(compDomNode) {
    var compId = compDomNode.id;
    return compDomNode.querySelector("[data-" + CONTENT_AREA_MARKER_NAME_IN_DOM + "=" + compId + "]");
  },
  getContentAreaMarkerForElement: function getContentAreaMarkerForElement(domNode) {
    var _ref2 = domNode || {},
        parentElement = _ref2.parentElement;

    if (!parentElement) {
      return null;
    }

    if (parentElement.dataset.meshInternal) {
      return contentAreaUtil.getContentAreaMarkerForElement(parentElement);
    }

    return _.find(parentElement.querySelectorAll("[data-" + CONTENT_AREA_MARKER_NAME_IN_DOM + "]"), {
      parentElement: parentElement
    });
  },
  getContentAreaStyle: function getContentAreaStyle(contentAreaWidth, alignment) {
    return {
      marginLeft: getContentAreaStartPosition(contentAreaWidth, alignment)
    };
  }
};
module.exports = contentAreaUtil;
//# sourceMappingURL=contentAreaUtil.js.map